module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#t1",
      "id": "c1"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#t1"
    }
  }, [_vm._v("EXCEPT BY PRAYER AND FASTING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("This kind does not go out except by prayer and fasting.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc0"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTHEW")]), _vm._v(" 17:21")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU’VE COMMANDED, REBUKED")]), _vm._v(", prayed prayers, done warfare, and shouted, but there’s more that needs to be broken off your life. It’s time to add some fasting to your warfare strategy. There is no other way around some demonic strongholds. No shortcuts. You have to fast and humble yourself until that thing breaks and leaves your life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Demons are different in terms of their wickedness. There are demons that are stronger, more wicked, unclean, and stubborn, and higher in rank, ability, and intelligence. The longer a demon has been in your family or in your life, the harder it is to remove because its roots go very deep. Demons such as rebellion, pride, witchcraft, Jezebel, poverty, and lack may only come out with a high level of faith.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes it seems as if they cannot be dislodged, and people will get discouraged and frustrated and feel they have failed. In Matthew 17 the disciples of Jesus encountered a demon in a young boy and could not cure him because of their unbelief. Unbelief hinders us from dealing with strongholds. It takes faith to dislodge the enemy. Fasting helps you overcome unbelief and build strong faith.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is the supernatural combination that Jesus gave His disciples in Matthew 17: prayer and fasting. I am not saying that when you fast you will earn brownie points with God or that you are working your way to enjoying God’s blessings. We don’t fast to be saved, please God, or go to heaven. There is no law that says if you don’t fast you will go to hell. We fast for breakthrough and revival, for family and loved ones. For the weapons of our warfare are not carnal but mighty through God!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Some things take fasting and prayer. There is no other way around. There are those kinds of demons that just don’t give up. They are strong, proud, arrogant, and defiant. They are familiar spirits that have been in your family. But you have to get to the point that you don’t care how messed up your family is; you say, “It is stopping with me. This is not going on to another generation. This is it, devil. If my grandmother or grandfather didn’t stand against it, if my mother and father didn’t defeat it, I’m going to defeat it. I refuse to be poor, broke, sick, rejected, messed up. . . . No!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes you have to do something unusual, extraordinary, and beyond the norm to see breakthrough. Normal church, normal Christianity, normal preaching, and normal praying are not going to get the job done. Some little sweet prayer is not going to do. Religion won’t get it done. It is going to take an anointing that destroys the yoke. When you fast, the anointing increases in your life because you are so into the Spirit. The authority of God, power of God, and faith of God comes alive when you lay aside some things and fast. You will find yourself getting stronger and stronger. Shouting doesn’t do it. It is the anointing that does it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Isaiah 58 talks about how we can fast to break every yoke to undo the heavy burdens. Fasting makes room so that the oppressed go free. Fasting breaks bondages and causes revival. When you are dealing with a serious issue—maybe you are dealing with something you don’t know how to handle—the best thing to do sometimes is to let go of some food for a little while. Pray against that thing. Man may not be able to help you, and you may not know how to defeat it, but with God all things are possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As you fast and humble yourself, the grace of God will come upon your life. The Lord will be the strength of your life. What you could not do in the flesh, you can do by the Spirit of God. Because it’s not by might nor by power, but by the Spirit of the Lord that every mountain is removed!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Listen, extraordinary situations require extraordinary measures. Sometimes it only happens when you get desperate—when you are so tired of being defeated and hindered in an area.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Let’s see some victories we haven’t seen before. Let’s get some breakthroughs we haven’t had before. Let’s see some miracles we haven’t seen before. Let’s drive out some demons we haven’t driven out before. Let’s see some curses broken that would not leave. Let’s see some generational stuff uprooted that could not be uprooted. Let’s see a change! Not once. Not twice. Not even three times. If you have to fast more times than that, do it. Don’t give up. Keep doing it. Keep going until you know you have victory, until you have breakthrough, until you sense something breaking!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You have to get so tired of the devil that you say, “Enough is enough. If I have to turn my plate down to get a breakthrough in this area, I won’t eat.” When your stomach starts screaming out, tell it to back up. In the end, you will win and have victory! Let our spiritual enemies be smitten and consumed in Jesus’s name!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You have to be determined: “No demon is going to control my life. I am a child of God, and who the Son sets free is free indeed. I don’t care how stubborn this thing is, how it tries to hang on. I am going to break every finger and thumb of the enemy. I’m going to break his wrists, break his grip. . . . Devil, you cannot have my life!” This is the faith and unshakable resolve fasting will build in your life to see deliverance in every area the enemy has tried to control.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW TO")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AST")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Fasting is beneficial whether you fast partially or fully. One-day fasts on a consistent basis will strengthen your spirit over time and give you the ability to discipline yourself for longer fasts. Three-day fasts with just water are a powerful way to see breakthroughs. Esther and the people of Israel went into a three-day fast when they were seeking deliverance from death at the hand of Haman, the king’s evil advisor (Esther 4:16). Fasts longer than three days should be done by people with more experience in fasting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I do not recommend long fasts unless there is an emergency or if one is led by the Holy Spirit to do so. Daniel fasted twenty-one days and saw a great breakthrough for his people (Dan. 9–10). Daniel was also a prophet, and God will use prophets to fast for different reasons to see breakthroughs. Jesus fasted forty days before beginning His ministry (Matt. 4:1–2). Moses and Elijah also fasted forty days (Exod. 34:28; Deut. 9:9, 18; 1 Kings 19:8). I do know of people who have fasted forty days and have seen great breakthroughs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A partial fast can include some food such as vegetables and can be done for long lengths. Complete fasts consist of only water, and water is important to cleanse the system of toxins that are released through fasting. The Holy Spirit will reveal to you when you need to fast. A fasted lifestyle is a powerful lifestyle.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPROACH")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTING")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMILITY AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INCERITY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("In Jesus’s day the Pharisees fasted with attitudes of pride and superiority:")]), _vm._v(" "), _c('div', {
    staticClass: "bkt1"
  }, [_c('p', {
    staticClass: "ext"
  }, [_vm._v("The Pharisee stood and prayed thus with himself, God, I thank thee, that I am not as other men are. . . . I fast twice in the week . . .")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("—L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 18:11–12, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Anytime you are full of pride, being legalistic and religious, you can fast and pray all you want, but you won’t see many miracles. The Pharisees didn’t have any miracles come as a result of their prayer and fasting. They had no power. Jesus had all the miracles because He was humble and full of mercy, love, and compassion toward people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Pharisees had nothing but long robes on—robes with no miracles. They couldn’t heal a headache, a mosquito bite, or a hangnail. They had no power because they were not humble and showed no mercy. Jesus showed up and broke all their rules. He healed the sick, raised the dead, and cast out devils. Then they wanted to kill him. They were not concerned about people. They were more concerned about their position and their title. Don’t ever get to a place where your position or title takes the humility and the mercy of God out of your life. Always be humble. Always be merciful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We must approach fasting with humility. Fasting must be genuine and not religious or hypocritical. This is what God requires in fasting. We must have correct motives in fasting. Fasting is a powerful tool if done correctly. Muslims and Hindus fast, but their fasts are merely religious. Great miracles and breakthroughs happen when fasting is done in the right spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx-2"
  }, [_vm._v("Isaiah chapter 58 describes the fast that God has chosen:")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Fasting cannot be done with amusement (v. 3).")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Fasting cannot be done while mistreating others (v. 3).")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Fasting cannot be done for strife or contention (v. 4).")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Fasting should cause one to bow his head in humility, like a bulrush (v. 5).")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Fasting should be a time of searching the heart and repenting (v. 5).")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Fasting should be done with an attitude of compassion for the lost and hurting (v. 7).")]), _vm._v(" "), _c('p', {
    staticClass: "tx-1"
  }, [_vm._v("This is the fast that God promises to bless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The enemy knows the power of prayer and fasting, and he will do everything in his power to stop you. Believers who begin to fast can expect to encounter much spiritual resistance. A believer must be committed to a fasted lifestyle. The rewards of fasting far outweigh the obstacles of the enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTING")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINGS AN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWARD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Fasting has great rewards. Many believers are unaware of the great rewards that come through fasting. Understanding the great benefits of fasting will motivate more believers to make it a regular part of their lives. Matthew 6:17–18 says, “But you, when you fast, anoint your head and wash your face, so that you will not appear to men to be fasting, but to your Father who is in secret. And your Father who sees in secret will reward you openly.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God promises rewards to those who fast in secret. Reward is God’s favor, abundance, and blessing. The open rewards of fasting include blessing, abundance, favor, and prosperity. Learn the secret of obtaining God’s reward through private fasting. Everybody doesn’t need to know you are fasting. As you are led by the Holy Spirit, make this a personal discipline between you and God and see how He rewards you.")]), _vm._v(" "), _c('div', {
    staticClass: "bkt1"
  }, [_c('p', {
    staticClass: "ext"
  }, [_vm._v("And without faith it is impossible to please God, for he who comes to God must believe that He exists and that He is a rewarder of those who diligently seek Him.")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBREWS")]), _vm._v(" 11:6")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECLARE THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEFITS OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTING")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VER")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])]), _vm._v(" "), _c('div', {
    staticClass: "bkt"
  }, [_c('p', {
    staticClass: "ext"
  }, [_vm._v("Lord, I believe in the power of Your chosen fast (Isa. 58).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Lord, let my fasting destroy the yokes that the enemy has set up against me.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let Your light come into my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let health and healing be released to me through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let me see breakthroughs of salvation and deliverance in my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let miracles be released in my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let Your power and authority be released in my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I humble my soul through fasting; let Your favor exalt me.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I drive every stubborn demon out of my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let Your covenant blessing and mercy be released on me through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Nothing is impossible with You, Lord; let my impossibilities become possibilities through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let every assignment of hell against me be broken through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let all pride, rebellion, and witchcraft operating in my life be destroyed through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let Your anointing increase in my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let me enjoy restoration through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let all carnality be rebuked from my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let all habits and iniquity in me be broken and overcome through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let my prayers be answered speedily through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Guide me through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Manifest Your glory to me through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let the strongholds of sexual impurity and lust be broken in my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let sickness and infirmity be destroyed in my life, and let healing come forth through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Let all poverty and lack be destroyed in my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Remove all oppression and torment from my life through Your chosen fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I humble myself with fasting (Ps. 35:13).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I will turn to the Lord with fasting, weeping, and mourning (Joel 2:12).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("This “kind” that I face will go out from me through fasting and prayer (Matt. 17:21).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I will fast according to the fast chosen by the Lord (Isa. 58:5).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I will proclaim a fast and humble myself before our God, to seek from Him the right way for my family and all our possessions (Ezra 8:21).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I fast to loose the bonds of wickedness, to undo heavy burdens, to let the oppressed go free, and to break every yoke (Isa. 58:6).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I will set my face toward the Lord God to make requests by prayer and supplication, with fasting, sackcloth, and ashes (Dan. 9:3).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I will fast in the secret place, and my Father sees in secret. He will reward me openly (Matt. 6:18).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I will not depart from the temple of the Lord but will serve God with fastings and prayers night and day (Luke 2:37).")]), _vm._v(" "), _c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 66
// module chunks = 0